export default "__VITE_ASSET__n1cODo8Q__"